// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). The legacy `margin: '- -Z2'` list pull compensated the old
// hand-rolled `padding: 'Z1 A'` body — MenuPanel pads Y and MenuPanelItem
// rows run full-width, so the pull (which would now overflow the panel by
// Z2 − Y and clip against the wrapper's overflow) is deleted. The per-row
// `':hover': { '& svg': ... }` opacity armor fought the retired
// KeyValueColumnFields/DropdownItem svg games and is gone with them.
const Dropdownmorefilesmenu = {
  extends: 'MenuPanel',
  Items: {
    flow: 'y',
    gap: '0',
    childExtends: 'MenuPanelItem',
    childProps: {
      isActive: (el, s) => el.key === s.activeContent,
      // Active row = the house `selected` wash + medium emphasis (§4.3) —
      // replaces DropdownItem's old gray6.15/white active pair. The nested
      // ':hover' pins the selected fill so hovering the active row does not
      // drop it back to the plain `hover` wash (DropdownItem did the same).
      '.isActive': {
        fontWeight: '500',
        background: 'selected',
        ':hover': {
          background: 'selected'
        }
      },
      onClick: (ev, el, s) => {
        const activeContent = el.key
        el.setWindow('explorer', 'explorer:' + activeContent)
        // el.setWindow('explorer', 'explorer', {
        //   forcedValue: activeContent
        // })
        // el.call('setSidebarContent', activeContent)
      },
      Icon: {
        order: '-1',
        margin: '- Y1 - -'
      }
    },
    childrenAs: 'props',
    children: (el) => [
      {
        key: 'ARTBOARD_TYPES',
        text: '{{ editor.panel.artboards | polyglot }}',
        Icon: {
          name: 'sf components'
        }
      },
      {
        key: 'FUNCTION_TYPES',
        text: '{{ editor.panel.functions | polyglot }}',
        Icon: {
          name: 'fnOutline'
        }
      },
      {
        key: 'STATE_TYPES',
        text: '{{ editor.panel.state | polyglot }}',
        Icon: {
          name: 'sfDocument'
        }
      },
      {
        key: 'ASSETS_TYPES',
        text: '{{ editor.panel.assets | polyglot }}',
        Icon: {
          name: 'sfAssets'
        }
      },
      {
        key: 'COLOR_TYPES',
        text: '{{ editor.panel.colors | polyglot }}',
        Icon: {
          name: 'sfPallete'
        }
      },
      {
        key: 'RESPONSIVE_TYPES',
        text: '{{ editor.panel.responsive | polyglot }}',
        Icon: {
          name: 'sfResponsive'
        },
        Sup: {
          color: 'disabled',
          margin: '-Z - - X2',
          fontSize: 'Y',
          text: '{{ editor.logoMenu.soon | polyglot }}'
        }
      },
      {
        key: 'TYPOGRAPHY_TYPES',
        text: '{{ editor.panel.typography | polyglot }}',
        Icon: {
          name: 'fontFace'
        },
        Sup: {
          color: 'disabled',
          margin: '-Z - - X2',
          fontSize: 'Y',
          text: '{{ editor.logoMenu.soon | polyglot }}'
        }
      },
      {
        key: 'SPACING_TYPES',
        text: '{{ editor.panel.spacing | polyglot }}',
        Icon: {
          name: 'spaceOutlineColored'
        },
        Sup: {
          color: 'disabled',
          margin: '-Z - - X2',
          fontSize: 'Y',
          text: '{{ editor.logoMenu.soon | polyglot }}'
        }
      },
      {
        key: 'ICON_TYPES',
        text: '{{ editor.panel.icons | polyglot }}',
        Icon: {
          name: 'iconsOutlineColored'
        }
      },
      {
        key: 'TRANSITION_TYPES',
        text: '{{ editor.panel.animations | polyglot }}',
        Icon: {
          name: 'animationsAlt'
        },
        Sup: {
          color: 'disabled',
          margin: '-Z - - X2',
          fontSize: 'Y',
          text: '{{ editor.logoMenu.soon | polyglot }}'
        }
      },
      {
        key: 'INTEGRATIONS_TYPES',
        text: '{{ editor.panel.integrations | polyglot }}',
        Icon: {
          name: 'fuse'
        }
      }
    ]
  }
}

export { Dropdownmorefilesmenu as 'Dropdown.MoreFilesMenu' }
